import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FileQuestion } from 'lucide-react';
import { Button } from '@ntconsult/aluma-react';

export function NotFoundPage() {
  const { t } = useTranslation('common');

  return (
    <div
      className="min-h-[100dvh] flex items-center justify-center bg-surface-raised"
      style={{
        paddingTop: 'max(env(safe-area-inset-top), 1rem)',
        paddingBottom: 'max(env(safe-area-inset-bottom), 1rem)',
      }}
    >
      <div className="text-center max-w-md px-4">
        <FileQuestion className="w-20 h-20 text-foreground-subtle mx-auto mb-6" />
        <h1 className="text-4xl font-bold text-foreground mb-2">404</h1>
        <h2 className="text-xl font-semibold text-foreground mb-4">{t('notFound.title')}</h2>
        <p className="text-foreground-muted mb-8">
          {t('notFound.message')}
        </p>
        <Link to="/">
          <Button>{t('notFound.backHome')}</Button>
        </Link>
      </div>
    </div>
  );
}
